module.exports = __webpack_public_path__ + "img/lv.210baf90.svg";